module.exports = __webpack_public_path__ + "img/hs_tokyo.40b9fa48.png";